module.exports = __webpack_public_path__ + "img/hkqaa.d52ea11f.png";